import * as hooks from './hooks';

export const useLiveGamesIntegration = () => {
    hooks.useLiveGamesCreateWS();
    hooks.useLiveGamesListeners();
    hooks.useLiveGamesConnectWS();
    hooks.useLiveGamesSetContextRequest();
};
